/** @type {Styles} */

export const styles = {
  buttonInputWrapper: {
    input: {
      display: 'none',
    },
  },
  buttonInputHidden: {
    display: 'none',
  },
  buttonInputErrorIcon: {
    color: 'error.main',
  },
  buttonInputError: {
    width: 'fit-content',
    alignItems: 'center',
    marginBottom: 1,
  },
}
